/**
 * @format
 */
import { Injectable } from "@angular/core";
import { createAction, props } from "@ngrx/store";
import {
   PreviewEditTemplate,
   PreviewTemplateContentResponse,
   TemplateParameterItemType,
} from "./preview-edit-template.model";
import { TemplateUpdateModel } from "./preview-edit-template.reducer";
import { UseImage } from "../../upload-images/types";

@Injectable()
export class PreviewEditTemplateActions {
   static openPreviewEditTemplateDialog = createAction(
      "[Template:Preview] Open Preview Edit Template Dialog",
      props<{
         templateModel: any;
         fileModel: any;
         isOnlyPreview: boolean;
         testUserName: string;
         testUserId: number;
         activeIndex: number;
         canEditDefault: boolean;
      }>()
   );

   static openPreviewEditTemplateDialogFromAngularJSSuccess = createAction(
      "[Template:Preview] Open Preview Edit Template Dialog Success (from Angular JS)"
   );

   static getModel = createAction(
      "[Template:Preview:Model] Get Model ",
      props<{
         templateId: any;
         templateFileRef?: string;
         updatedModel?: any;
         selectedUserId: any;
      }>()
   );
   static getModelSuccess = createAction(
      "[Template:Preview:Model] Get Model success",
      props<{
         previewEditTemplate: Array<PreviewEditTemplate>;
         templateId: any;
         selectedUserId: any;
      }>()
   );
   static getModelFail = createAction(
      "[Template:Preview:Model] Get Model failed",
      props<{ previewEditTemplate: Array<PreviewEditTemplate> }>()
   );

   static preprocessModel = createAction(
      "[Template:Preprocess:Model] Preprocess Model",
      props<{
         mediaType: any;
         template: any;
         templateId: any;
         selectedUserId: any;
      }>()
   );
   static preprocessModelSuccess = createAction(
      "[Template:Preprocess:Model] Preprocess Model success",
      props<{ contextVariables: Array<any> }>()
   );
   static preprocessModelFail = createAction("[Template:Preprocess:Model] Preprocess Model fail");

   static saveModel = createAction(
      "[Template:Preview:Model] Save Model ",
      props<{
         templateId: number;
         isConfirmed: boolean;
         forRevert: any;
         template: any;
         userId: number;
         lastModified: any;
      }>()
   );
   static saveModelSuccess = createAction(
      "[Template:Preview:Model] Save Model Success ",
      props<{ templateId: any; lastModified: any }>()
   );

   static processPreviewTemplate = createAction(
      "[Template:Preview:Message:Content] Get Email and Voice Content ",
      props<{
         templateId: number;
         userId: number;
         model: any;
         templateFilename: string;
         isConfirm: boolean;
      }>()
   );
   static processPreviewTemplateSuccess = createAction(
      "[Template:Preview:Message:Content] Get Email and Voice Content success",
      props<{ contentResponse: PreviewTemplateContentResponse }>()
   );
   static processPreviewTemplateFail = createAction(
      "[Template:Preview:Message:Content] Get Email and Voice Content fail",
      props<{ error: any }>()
   );

   static saveSource = createAction(
      "[Template:Preview:Source] Save Source ",
      props<{
         templateId: number;
         template: any;
         userId: number;
         model: any;
         templateFilename: string;
         isConfirm: boolean;
      }>()
   );
   static saveSourceSuccess = createAction(
      "[Template:Preview:Source] Save Source success",
      props<{
         templateId: any;
         userId: number;
         model: any;
         templateFilename: string;
         lastModified: any;
         isConfirm: boolean;
      }>()
   );

   static validateSource = createAction(
      "[Template:Preview:Source] Validate Source ",
      props<{
         template: any;
         userName: any;
         userId: any;
         fileName: any;
         updatedModel: any;
         templateId: any;
         isConfirm: boolean;
      }>()
   );
   static validateSourceSuccess = createAction(
      "[Template:Preview:Source] Validate Source success",
      props<{
         userId: any;
         templateFilename: any;
         model: any;
         templateId: any;
         isConfirm: boolean;
      }>()
   );

   static saveAsCustomTemplate = createAction(
      "[Template:Save:Custom] Save as Custom Template ",
      props<{ template: any; userId: number; model: any; source: any; saveType: any }>()
   );

   static deleteTmpFile = createAction("[Template:Delete]  Delete temp source file", props<{ fileName: any }>());
   static deleteTmpFileSuccess = createAction("[Template:Delete]  Delete temp source file Success");

   static getTemplateParameters = createAction(
      "[Template:Preview:TemplateParameters] Get Template Parameters ",
      props<{ userId: any; categoryType: any }>()
   );
   static getTemplateParametersSuccess = createAction(
      "[Template:Preview:TemplateParameters] Get Template Parameters success",
      props<{ templateParameters: Array<TemplateParameterItemType> }>()
   );

   static getLocations = createAction("[Template:Preview:Locations] Get Locations ", props<{ userId: any }>());
   static getLocationsSuccess = createAction(
      "[Template:Preview:Locations] Get Locations success",
      props<{ locations: Array<any> }>()
   );

   static getLocationEntities = createAction("[Template:Preview:LocationEntities] Get LocationEntities ", props<{ userId: any }>());
   static getLocationEntitiesSuccess = createAction(
      "[Template:Preview:LocationEntities] Get LocationEntities success",
      props<{ locationEntities: Array<any> }>()
   );

   static getProviders = createAction("[Template:Preview:Providers] Get Providers ", props<{ userId: any }>());
   static getProvidersSuccess = createAction(
      "[Template:Preview:Provider] Get Providers success",
      props<{ providers: Array<any> }>()
   );

   static displayDialogOnError = createAction(
      "[Template:Preview:Error] Display Dialog on Error",
      props<{ error: string }>()
   );

   // In Safari, we are having lots of issue when working with templates updating model
   static templateUpdateModel = createAction(
      "[Template:Preview] Update TemplateUpdateModel ",
      props<{ templateUpdateModel?: TemplateUpdateModel }>()
   );

   static templateUpdateModelVariable = createAction(
      "[Template: Preview] Update Variable in Template",
      props<{ variableName: string; value: string; reloadPreview: boolean }>()
   );

   static updateMedia = createAction("[Template:Preview] Update Media ", props<{ mediaDevices: Array<any> }>());

   static getCountOfStrategiesMappedWithTemplate = createAction(
      "[Template:Preview] Get Count Of Strategies Mapped With Template ",
      props<{ templateId: string; selectedUserName: string }>()
   );

   static getCountOfStrategiesMappedWithTemplateSuccess = createAction(
      "[Template:Preview] Get Count Of Strategies Mapped With Template Success",
      props<{ totalStrategies: number }>()
   );

   static saveMedia = createAction(
      "[Template:Preview] Save Media ",
      props<{ mediaDevices: Array<any>; templateId: number }>()
   );

   static saveMediaSuccess = createAction("[Template:Preview] Save Media Success ");

   static useImageUploaded = createAction(
      "[Template:Preview] Use Image Uploaded ",
      props<{
         imagesList: Array<UseImage>;
         imageUrl: string;
         variableName: string;
         reload: boolean;
      }>()
   );

   static isTemplateUsed = createAction(
      "[Template:Preview:Model] Is Template Used ",
      props<{
         templateId: any;
         userId: any;
         communicationsCategoryId: any;
         updatedModel: any;
         shouldOnlyUpdateFileRef: any;
         mediaDevices: any;
         isModelUpdated: boolean;
      }>()
   );
   static isTemplateUsedSuccess = createAction(
      "[Template:Preview:Model] Is Template Used success",
      props<{
         templateState: any;
      }>()
   );

   static setSavingStatus = createAction("[Template:Preview] Set Saving Status", props<{ savingStatus: boolean }>());
   static setSmsPartsAndParsedTextLength = createAction(
      "[Template:Preview] Set SMS Parts and ParsedTextLength",
      props<{ smsParts: number; smsParsedTextLength: number }>()
   );
   static setEmailPreventChanges = createAction(
      "[Template:Preview] Set Email Prevent Changes",
      props<{ preventChanges: boolean }>()
   );
   static setMessagePreventChanges = createAction(
      "[Template:Preview] Set Message Prevent Changes",
      props<{ preventChanges: boolean }>()
   );
}
